import { CompositeSessionInfoSelectors, SessionSiteSelectors, SessionUserSelectors } from '~selectors/SessionInfoSelectors';

import { AppState } from '../../app/state/AppState';
import { IDatasourceActions } from '../../datasource/ServerApi/types/IDatasourceActions';
import { IUserInfo } from '../../ts/models/IUserInfo';
import { IViewBase } from '../../ts/models/IViewInfo';
import { IOwnedItemInfo } from '../../ts/models/resourceInfoParts';
import { Views } from '../../views/resources/Views';
import { IWorkbookActions } from '../../workbook/ServerApi/types/IWorkbookActions';
import { IContentInfo } from '../models/IContentInfo';

export function getOwnerIdForView(item: IContentInfo | IViewBase): string {
  if (!item) {
    return null;
  }
  if (Views.isViewBase(item)) {
    return (item.workbook && item.workbook.owner) ? item.workbook.owner.id : null;
  }
  return item.owner ? item.owner.id : null;
}

export function isOwnedItemInfo(item: any): item is IOwnedItemInfo {
  return item && item.hasOwnProperty('owner');
}

export function getOwnerForItem(item: any): IUserInfo {
  if (isOwnedItemInfo(item)) {
    return item.owner;
  }
  return null;
}

export function currentUserIsOwner(state: AppState, item: any): boolean {
  const owner = getOwnerForItem(item);
  const ownerId = owner && owner.id;
  return ownerId === SessionUserSelectors.sessionUserId(state);
}

export function currentUserIsOwnerOrAdmin(state: AppState, item: any): boolean {
  return currentUserIsOwner(state, item) || currentUserIsAdmin(state);
}

export function currentUserIsAdmin(state: AppState): boolean {
  return SessionUserSelectors.isSessionServerAdmin(state)
  || SessionSiteSelectors.isSessionSiteAdmin(state);
}

export function hasExtractRefreshPermission(
  state: AppState,
  item: any,
  availableActions: IWorkbookActions | IDatasourceActions,
): boolean {
  return currentUserIsOwnerOrAdmin(state, item)
    || (availableActions && availableActions.refreshExtract);
}

export function hasRunNowPermission(state: AppState): boolean {
  // Backend handles all the complex logic for determining if it's actually enabled
  return CompositeSessionInfoSelectors.isRunNowEnabled(state);
}
